module.exports = __webpack_public_path__ + "static/img/activityTiger-1.57a0b5e2.png";